import { FC } from "react";

import { Spinner, Stack, Text } from "@bps/fluent-ui";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { VerticalTabs } from "@components/VerticalTabs";
import { useOpsReportsDefinitions } from "@libs/api/gateways/plt-reports-ops/plt-reports-ops-gateway.hooks";

interface ReportsTabsProps {
  selectedTab: string | undefined;
  onSectionChange: (nextId: string) => void;
}

export const ReportsTabs: FC<ReportsTabsProps> = ({
  selectedTab,
  onSectionChange
}) => {
  const reportsQuery = useOpsReportsDefinitions({
    metaData: {
      ReportType: "ENV_Report"
    }
  });
  return (
    <QueryStateIndicator
      {...reportsQuery}
      LoadingComponent={
        <Stack tokens={{ childrenGap: 16 }}>
          <Text variant="large">Reports</Text>
          <Spinner />
        </Stack>
      }
      NoDataNode={<div />}
    >
      {response => {
        return (
          <VerticalTabs
            title="Reports"
            tabs={response.map(item => ({
              ...item,
              id: `ops-reports/${item.name}`
            }))}
            selectedTab={selectedTab}
            onSelectedTabChange={onSectionChange}
          />
        );
      }}
    </QueryStateIndicator>
  );
};
